import React, { useState, useEffect } from "react";
import axios from "axios";
import "./FormPage.css";
import { useNavigate, useLocation } from "react-router-dom";

const FormPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    address: "",
    hospitalName: "",
    doctorName: "",
    hospitalAddress: "",
    appointmentDate: "", 
  });

  // Use the passed data to pre-populate the form
  useEffect(() => {
    if (location.state) {
      const { doctorName, hospitalName, hospitalAddress } = location.state;
      setFormData((prev) => ({
        ...prev,
        doctorName: doctorName || "",
        hospitalName: hospitalName || "",
        hospitalAddress: hospitalAddress || "",
      }));
    }
  }, [location]);

  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false); // Show popup flag
  const [isChecking, setIsChecking] = useState(false); // Track checking state

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsChecking(true); // Start checking animation

    try {
      const response = await axios.post(
        "https://api.swasthmitra.com/api/appointment/submit",
        formData
      );
      setMessage(response.data.message);
      setShowPopup(true); // Show popup after successful submission
      setFormData({
        name: "",
        mobileNumber: "",
        address: "",
        hospitalName: "",
        doctorName: "",
        hospitalAddress: "",
      });
    } catch (error) {
      setMessage("Error in form submission");
    } finally {
      setIsChecking(false); // End checking animation
    }
  };

  const closePopup = () => {
    setShowPopup(false); // Close the popup when cross button is clicked
    navigate("/home");
  };

  return (
    <div className="form-wrapper">
      <h1 className="form-title">Schedule an Appointment</h1>
      {message && (
        <div
          className={`response-message ${
            message === "Error in form submission"
              ? "error-message"
              : "success-message"
          }`}
        >
          {message}
        </div>
      )}

      <form className="form-content" onSubmit={handleSubmit}>
        <div className="input-group">
          <label className="form-label">Name</label>
          <input
            className="form-input"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            required
          />
        </div>
        <div className="input-group">
  <label className="form-label">Appointment Date</label>
  <input
    className="form-input"
    type="date"
    name="appointmentDate"
    value={formData.appointmentDate}
    onChange={handleChange}
    required
  />
</div>

        <div className="input-group">
          <label className="form-label">Mobile Number</label>
          <input
            className="form-input"
            type="tel"
            name="mobileNumber"
            value={formData.mobileNumber}
            onChange={handleChange}
            placeholder="Enter your mobile number"
            required
          />
        </div>

        <div className="input-group">
          <label className="form-label">Your Address</label>
          <input
            className="form-input"
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter your address"
            required
          />
        </div>

        <div className="input-group">
          <label className="form-label">Hospital Name</label>
          <input
            className="form-input"
            type="text"
            name="hospitalName"
            value={formData.hospitalName}
            onChange={handleChange}
            placeholder="Enter hospital name"
            required
            readOnly={location.state?.hospitalName}
          />
        </div>

        <div className="input-group">
          <label className="form-label">Doctor Name</label>
          <input
            className="form-input"
            type="text"
            name="doctorName"
            value={formData.doctorName}
            onChange={handleChange}
            placeholder="Enter doctor's name"
            required
            readOnly={location.state?.doctorName}
          />
        </div>

        <div className="input-group">
          <label className="form-label">Hospital Address</label>
          <input
            className="form-input"
            type="text"
            name="hospitalAddress"
            value={formData.hospitalAddress}
            onChange={handleChange}
            placeholder="Enter hospital address"
            required
            readOnly={location.state?.hospitalAddress}
          />
        </div>

        <button className="submit-button" type="submit">
          Book Appointment
        </button>
      </form>

      {/* Popup with tick animation */}
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <div className="close-btn" onClick={closePopup}>
              ×
            </div>
            {isChecking ? (
              <div className="checking-animation">Checking...</div> // Display checking message during process
            ) : (
              <div className="tick-animation">
                <div className="tick-mark">✔</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FormPage;
